import { combineReducers } from 'redux';
import alert from './alert';
import auth from './auth';
import breadcrumb from './breadcrumb';
import loader from './loader';

export default combineReducers({
    alert,
    auth,
    breadcrumb,
    loader
});
